import React from "react";

import { ButtonStandard, Chip, ProgressBar, Text } from "@performyard/py-components";

import { Divider } from "../../../../../components/Divider";

import type { GroupBudgetFigures } from "../types";

import { formatCurrencyFull } from "../../../utils";

export type BudgetSummaryCardProps = {
	figures: GroupBudgetFigures;
	onViewAuditLog: () => void;
};

export const BudgetSummaryCard = ({ figures, onViewAuditLog }: BudgetSummaryCardProps): React.ReactElement => {
	const { groupIncreaseBudget, groupAllocated, groupPercentAllocated, groupRemaining, isGroupOverBudget } = figures;

	return (
		<div
			className="flex flex-col gap-4 rounded-sm bg-white p-4"
			style={{ border: "1px solid var(--py-neutral-2)" }}
		>
			<div className="flex items-center">
				<div className="flex items-stretch gap-8">
					<div className="flex flex-col gap-1">
						<Text size="paragraph-3" color="neutral-7">
							Increase Budget
						</Text>
						<Text size="heading-5" weight="semi-bold">
							{formatCurrencyFull(groupIncreaseBudget)}
						</Text>
					</div>
					<Divider orientation="vertical" />
					<div className="flex flex-col gap-1">
						<Text size="paragraph-3" color="neutral-7">
							Allocated
						</Text>
						<div className="flex items-center gap-2">
							<Text size="heading-5" weight="semi-bold">
								{groupAllocated === 0 ? "$0" : formatCurrencyFull(groupAllocated)}
							</Text>
							<Chip
								size={20}
								color={isGroupOverBudget ? "red" : "green"}
								label={`${groupPercentAllocated}%`}
							></Chip>
						</div>
					</div>
					<Divider orientation="vertical" />
					<div className="flex flex-col gap-1">
						<Text size="paragraph-3" color="neutral-7">
							Remaining
						</Text>
						<Text size="heading-5" weight="semi-bold">
							{groupRemaining === 0 ? "$0" : formatCurrencyFull(groupRemaining)}
						</Text>
					</div>
				</div>
				<div className="ml-auto w-[105px] shrink-0 pr-4">
					<ButtonStandard
						variant="outline"
						color="neutral"
						size={"medium"}
						dangerouslySetClassName={
							"!w-auto w-[105px] !border-neutral-3 !text-neutral-7  !text-paragraph-3"
						}
						onClick={onViewAuditLog}
					>
						View Audit Log
					</ButtonStandard>
				</div>
			</div>
			<ProgressBar value={Math.min(100, groupPercentAllocated)} color={isGroupOverBudget ? "red" : "green"} />
		</div>
	);
};
